/**
 * Extension Integration Validators
 *
 * Backend is responsible for:
 * 1. Looking up brand/model IDs
 * 2. Matching variants
 * 3. Building search URLs
 * 4. Creating jobs with all rounds
 */
import { z } from "zod";
export const extensionVehicleDataSchema = z.object({
    /**
     * Brand name (required for DB lookup)
     */
    brand: z.string().min(1).max(100),
    /**
     * Model name (required for DB lookup)
     */
    model: z.string().min(1).max(100),
    /**
     * Variant/trim (optional, used for variant matching)
     */
    variant: z.string().max(200).optional(),
    /**
     * Engine power in kW (used for variant matching)
     */
    power_kw: z.number().int().positive().optional(),
    /**
     * Year of manufacture
     */
    year: z.number().int().min(1900).max(new Date().getFullYear() + 1).optional(),
    /**
     * Mileage in km
     */
    mileage: z.number().int().nonnegative().optional(),
    /**
     * Fuel type
     */
    fuel: z.string().max(50).optional(),
    /**
     * Transmission type
     */
    transmission: z.string().max(50).optional(),
    /**
     * Vehicle type/body style (e.g., "Kombi", "Limousine")
     */
    vehicle_type: z.string().max(50).optional(),
    /**
     * VIN (optional, for reference)
     */
    vin: z.string().min(17).max(17).optional(),
    /**
     * Listed price
     */
    price: z.number().nonnegative().optional(),
    /**
     * Taxation type (e.g., "Regelbesteuert", "Pauschalbesteuert")
     */
    taxation: z.string().max(50).optional(),
    /**
     * Custom ID for user reference
     */
    custom_id: z.string().max(100).optional(),
});
/**
 * Extension scrape job request schema
 *
 * Minimal data required - backend does all the heavy lifting!
 */
export const extensionScrapeJobSchema = z.object({
    /**
     * Always "extension"
     */
    source: z.literal("extension"),
    /**
     * Vehicle data from website
     * Backend will:
     * - Look up brand/model IDs in DB
     * - Match variant to existing variants
     * - Build search URL with all parameters
     * - Create job with rounds
     */
    vehicle_data: extensionVehicleDataSchema,
});
/**
 * Job status response schema
 */
export const extensionJobStatusSchema = z.object({
    id: z.string().uuid(),
    status: z.enum(["pending", "processing", "completed", "failed"]),
    results_count: z.number().int().nonnegative(),
});
/**
 * Batch status response schema
 */
export const extensionJobsStatusResponseSchema = z.object({
    jobs: z.array(extensionJobStatusSchema).max(100),
});
//# sourceMappingURL=extension.schema.js.map